import { render, staticRenderFns } from "./SpeechExplainView.vue?vue&type=template&id=3ed716e8&scoped=true"
import script from "./SpeechExplainView.vue?vue&type=script&lang=js"
export * from "./SpeechExplainView.vue?vue&type=script&lang=js"
import style0 from "./SpeechExplainView.vue?vue&type=style&index=0&id=3ed716e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed716e8",
  null
  
)

export default component.exports